import type { commun as Fr } from '../fr/commun';

/** Shared texts — typed on the French: a missing sentence does not compile. */
export const commun: typeof Fr = {
  statuts: {
    option: 'Option', confirmee: 'Confirmed', en_cours: 'Ongoing', terminee: 'Completed',
    annulee: 'Cancelled', non_restitue: 'Not returned',
    disponible: 'Available', loue: 'Rented', entretien: 'Maintenance', immobilise: 'Off the road', vendu: 'Sold',
    archive: 'Archived',
    detenue: 'Held', restituee: 'Returned', retenue_partielle: 'Partly withheld', saisie: 'Forfeited',
    brouillon: 'Draft', actif: 'Active', clos: 'Closed', resilie: 'Terminated',
    en_attente: 'Pending', accordee: 'Approved', refusee: 'Declined',
    non_declare: 'Not reported', declare: 'Reported', expertise: 'Assessment',
    accepte: 'Accepted', refuse: 'Rejected', rembourse: 'Reimbursed',
  },
  roles: {
    gerant_finances: 'Owner · finance',
    gerant: 'Manager',
    agent: 'Counter agent',
  },
  actions: {
    annuler: 'Cancel', enregistrer: 'Save', fermer: 'Close', valider: 'Confirm',
    modifier: 'Edit', supprimer: 'Delete', ajouter: 'Add', imprimer: 'Print',
    rechercher: 'Search', reessayer: 'Try again', retour: 'Back', suivant: 'Next',
    precedent: 'Previous', confirmer: 'Confirm', voir: 'View', ouvrir: 'Open',
  },
  langue: { choisir: 'Language', changer: 'Change language' },
  chargement: 'Loading…',
  aucun: 'None',
  oui: 'Yes',
  non: 'No',
  erreurReseau: 'The server is not responding',
  erreurGenerique: 'Something went wrong',
  pluriel: (n, un, plusieurs) => `${n} ${n === 1 ? un : plusieurs}`,
};
